<template>
  <div class="coupon-card" @click="onChange">
    <div class="coupon-card-left">
      <div class="coupon-card-title">U泊停车</div>
      <strong>副券</strong>
      <div class="coupon-card-code">{{coupon.code}}</div>
    </div>
    <div class="coupon-card-content">
      <div class="coupon-card-title"><span>U泊停车</span><span v-if="coupon.merchantName"> | {{coupon.merchantName}}</span></div>
      <div class="coupon-card-amount">
        <div class="coupon-card-amount-value" :style="{'font-size': coupon.type === 'FREE_COUPON' ? '30px' : 'parent'}">{{amount.value}}</div>
        <div class="coupon-card-amount-right">
          <div class="coupon-card-amount-unit">{{amount.unit}}</div>
          <div>停车券</div>
        </div>
      </div>
      <div>
        <div class="coupon-card-title">{{expired}}</div>
        <div class="coupon-card-title" v-if="coupon.applicableParkingLotName">仅限{{coupon.applicableParkingLotName}}使用</div>
      </div>
    </div>
    <div class="coupon-card-right">
      <div class="coupon-card-status">
        <van-tag :color="status.color">{{status.name}}</van-tag>
      </div>
      <div class="coupon-card-action">
        <van-checkbox v-model="value" v-show="selectable"></van-checkbox>
      </div>
    </div>
  </div>
</template>
<script>
import { Checkbox, Icon, Tag } from 'vant'
import dayjs from 'dayjs';

const couponValue = (value, type) => {
  if (type === 'TIME_COUPON') {
      if (value / (60 * 24) >= 1) {
        return { value: Math.floor(value/(60 * 24)), unit : '天'}
      }
      if (value / 60 >= 1) {
        return { value: Math.floor(value/60), unit : '小时'}
      }
      return { value: value, unit : '分钟'}
    } else if (type === 'PRICE_COUPON') {
      return { value: value/ 100, unit : '元'};
    } else if (type === 'FREE_COUPON') {
      return { value: '全免', unit : ''};
    }
    return {value: 0, type: ''};
}

const coubineCoupons = coupons => {
  const couponCoubine = {};
  (coupons || []).forEach(coupon => {
    const {value, type} = coupon;
    const key = type + value;
    let data = couponCoubine[key];
    if (data) {
      couponCoubine[key] = {...data, count: data.count + 1};
    } else {
      
      const amount = couponValue(value, type);
      let name = '免'+ amount.value + amount.unit;
      if (type === 'FREE_COUPON') {
        name = amount.value + '券'
      }

      couponCoubine[key] = { name, count: 1}
    }
  });
  return couponCoubine;
}

const component = {
  name: 'Coupon',
  components: {
    [Icon.name] : Icon,
    [Tag.name] : Tag,
    [Checkbox.name] : Checkbox
  },
  model: {
    prop: 'checked',
    event: 'click'
  },
  data() {
    return {
      value : this.checked
    }
  },
  props: {
    coupon : Object,
    selectable: Boolean,
    checked: Boolean
  },
  methods: {
    onChange() {
      if (this.selectable) {
        this.$emit('click', !this.value, this.coupon.code);
      }
    }
  },
  watch: {
    checked: function(n) {
      this.value = n;
    }
  },
  computed : {
    status() {
      const { usedTime,  applicable} = this.coupon;
      if (usedTime) {
        return {name: '已使用', color: 'gray'};
      } else if (applicable){
        return {name: '可用', color: '#00c266'};
      }
      return { name: '不可用', color: 'gray'}
    },
    amount() {
      const {value, type} = this.coupon;
      return couponValue(value, type);
    }, 
    expired() {
      const start = this.coupon.activeTime;
      const end = this.coupon.expiredTime;
      const format = 'YYYY.MM.DD';
      if (!start && !end) {
        return '永久有效';
      }
      if (start && !end) {
        return dayjs(start).format(format) + '开始生效';
      }
      if (!start && end) {
        return '至' + dayjs(end).add(-1, 'day').format(format)
      }
      return dayjs(start).format(format) + ' - ' + dayjs(end).add(-1, 'day').format(format)
    }
  }
}

export default component;
export {couponValue, coubineCoupons};
</script>
<style lang="less" scoped>
  .coupon-card {
    display: flex;
    justify-content: space-between;
    background-color: white;
    margin: 10px;
    padding: 10px 0;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.1);
  }
  .coupon-card-left {
    border-right: 1px dashed #ebedf0;
    text-align: center;
    flex: 0 0 90px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    strong {
      font-size: 20px;
      font-weight: bold;
    }

    .coupon-value {
      font-weight: bold;
      font-size: 16px;

      strong {
        font-size: 26px;
      };
    }
  }
  .coupon-card-content {
    padding : 0 10px;
    flex: 1;
    
    .coupon-card-amount {
      display: flex;
      justify-content: space-between;
      width: 160px;
      margin: 10px 0;
      align-items: flex-end
    }
    .coupon-card-amount-value {
      text-align: right;
      font-size: 40px;
      font-weight: bold;
      flex: 1;
      padding-right: 10px;
      line-height: 36px;
    }
    .coupon-card-amount-right {
      flex: 0 0 55px;
      font-size: 12px;
    }
  }
  .coupon-card-right {
    flex: 0 0 50px;
    justify-content: space-between;
    display: flex;
    flex-direction: column;
    text-align: right;
    padding-right: 10px;

    .coupon-card-status {
      flex: 0 0 30px;
    }

    .coupon-card-action {
      text-align: center;
      justify-content: center;
      display: flex;
      flex: 1;
      flex-direction: column;
    }
  }
  .coupon-card-code {
    font-family: Consolas, Monaco, Menlo, 'Courier New', Courier, monospace;
    color: gray;
    font-size: 12px;
  }
  .coupon-card-title {
    color: gray;
    font-size: 12px;
  }
  .coupon-card-status {
    font-size: 18px;
    color: green;
  }

</style>